export default ({ data, renderItem, renderEmpty = () => null }) =>
  data.length > 0 ? data.map((page, index) => renderItem(page, index)) : renderEmpty();
